import { useEffect, useState } from "react";

/**
 * Returns the current "identity" from localStorage and stays in sync
 * with cross-component changes via the custom 'lo_identity_changed' event.
 */
export function useIdentity() {
  const read = () => ({
    email: localStorage.getItem("lo_email") || "",
    firstName: localStorage.getItem("lo_first_name") || "",
  });
  const [identity, setIdentity] = useState(read);

  useEffect(() => {
    const sync = () => setIdentity(read());
    window.addEventListener("lo_identity_changed", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("lo_identity_changed", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const setIdentity_ = ({ email, firstName }) => {
    if (email) localStorage.setItem("lo_email", email.toLowerCase().trim());
    if (firstName) localStorage.setItem("lo_first_name", firstName.trim());
    window.dispatchEvent(new Event("lo_identity_changed"));
  };
  const clearIdentity = () => {
    localStorage.removeItem("lo_email");
    localStorage.removeItem("lo_first_name");
    window.dispatchEvent(new Event("lo_identity_changed"));
  };

  return { identity, setIdentity: setIdentity_, clearIdentity };
}
